import { AavoButtonProps } from "src/components/common/buttons/AavoButton.tsx";
import { useOpenLegacyView } from "src/components/views/legacy/hooks.ts";
import i18n from "i18next";
import {
	openLegacyCustomerOrderDeliveryView,
} from "src/components/views/legacy/legacyViewAdapters.ts";
import { faFileInvoiceDollar } from "@fortawesome/pro-regular-svg-icons";
import { AsyncButtonContextMenuItem } from "src/components/common/contextMenu/AsyncButtonContextMenuItem.tsx";
import { useTenantCustomizations } from "src/tenantCustomizations/useTenantCustomizations.tsx";
import { ValueOrProvider, resolveValueOrProvider } from "src/utils/valueOrProvider.ts";

export interface OpenCustomerOrderDeliveryContextMenuButtonProps extends Omit<AavoButtonProps, "onClick"> {
	customerOrderId: ValueOrProvider<number>;
	customerOrderDeliveryId: ValueOrProvider<number>;
}

export const OpenCustomerOrderDeliveryContextMenuButton = ({
	customerOrderId: customerOrderIdOrProvider,
	customerOrderDeliveryId: customerOrderDeliveryIdProvider,
}: OpenCustomerOrderDeliveryContextMenuButtonProps) => {
	const openLegacyView = useOpenLegacyView();

	const { tenantConfig } = useTenantCustomizations();
	if (!tenantConfig.erp.salesEnabled) return null;

	return (
		<AsyncButtonContextMenuItem
			label={i18n.t("open_delivery")}
			icon={faFileInvoiceDollar}
			onClick={() => {
				const customerOrderId = resolveValueOrProvider(customerOrderIdOrProvider);
				const customerOrderDeliveryId = resolveValueOrProvider(
					customerOrderDeliveryIdProvider,
				);
				openLegacyCustomerOrderDeliveryView(
					openLegacyView,
					customerOrderId,
					customerOrderDeliveryId,
				);
			}}
		/>
	);
};
